import { z } from 'zod';

/**
 * Assembly details validation schema
 * Used when marking an order as assembled
 */
const assemblySchema = z.object({
    /** Whether assembly has been completed */
    isComplete: z.boolean(),
    /** Date assembly was completed in ms since epoch */
    dateAssembled: z.number().int().positive().optional(),
    /** Name/ID of agent who performed assembly */
    agent: z.string().optional(),
    /** Any notes from assembly */
    notes: z.string().optional(),
});
/**
 * Mark assembled body schema (for POST /:orderId/mark-assembled)
 */
const markAssembledBodySchema = z.object({
    assembly: assemblySchema,
});
/**
 * Mark assembled form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markAssembledFormSchema)
 */
const markAssembledFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm that the vehicle assembly is complete',
    }),
});

export { assemblySchema, markAssembledBodySchema, markAssembledFormSchema };
//# sourceMappingURL=assemblyValidation.js.map
